import * as React from "react";
import { MultipleItemsProperty } from "./MultipleItemsProperty";
import { ICFButton, ICFLabel, ICardProps } from "./ItemCard";
import { Checkbox, IItemCardProps, Input, ToggleFilter } from "uxp/components";
import IconEditor from "../../icon-selector/IconEditor";
import { CustomColorPicker, Property, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../ui-props/common";
import { ImagePicker } from "lucy/common-components";
import { applyAtPath } from "../../common";
import { WidgetDesignerPillInput } from "../../pill-input/PillInput";
import ActionEditorLink from "../../action-editor/ActionEditor";
import { IContextData } from "../../../../hooks/useContextData";

export function LabelProperties(items: ICFLabel[], onChange: (items: ICFLabel[]) => void, contextData: IContextData) {
    return <MultipleItemsProperty<ICFLabel>
        items={items || []}
        newItem={() => ({ icon: 'tag', backgroundColor: '#FFAAAA', color: '#424242', fontSize: '10px', text: 'My Label', type: 'normal' })}
        onChange={(items) => onChange(items)}
        render={(item, onChange) => {
            return <div className='cf-label-item'>
                <div className='cf-m-f'>
                    <label>Text</label>
                    {/* <Input value={item.text} onChange={(s) => onChange({ ...item, text: s })} /> */}

                    <WidgetDesignerPillInput
                        value={item.text}
                        onChange={(s) => onChange({ ...item, text: s })}
                        className={'widget-designer-pill-input'}
                        placeholder={"Longitude"}
                        contextData={contextData}
                    />

                </div>

                <div className='cf-m-f'>
                    <label>Icon</label>
                    <IconEditor onChange={(s) => onChange({ ...item, icon: s })} value={item.icon} />
                </div>
                <div className='cf-m-f'>
                    <label>Color</label>
                    <CustomColorPicker contextData={contextData} color={item.color} onChange={(c) => onChange({ ...item, color: c })} />
                </div>
                <div>
                    <ToggleFilter options={[
                        { label: 'Normal', value: 'normal' },
                        { label: 'Pill', value: 'pill' },
                    ]}
                        value={item.type}
                        onChange={(s) => onChange({ ...item, type: s })}
                    />
                </div>
                {item.type == 'pill' && <div className='cf-m-f'>
                    <label>Background</label>
                    <CustomColorPicker contextData={contextData} color={item.backgroundColor} onChange={(c) => onChange({ ...item, backgroundColor: c })} />
                </div>}

            </div>

        }}
        title=""

    />
}
interface IItemCardPropertyEditorProps {
    uiProps: ICardProps;
    onChange: (newProps: ICardProps) => void;
    parentUIProps: any;
}
export const ItemCardPropertyEditor: React.FunctionComponent<any> = (props) => {
    const uiProps = props.uiProps;
    return <><PropertyGroup>
        <PropertyGroupTitle>Image</PropertyGroupTitle>
        <Property>

            <ToggleFilter className={'cf-image-toggle'} options={[{ label: 'Image', value: 'image' }, { label: 'Icon', value: 'icon' }]} value={uiProps.imageType}
                onChange={(v) => {
                    props.onChange(Object.assign({}, uiProps, { imageType: v }));
                }}
            />
        </Property>
        <Property>
            <Checkbox checked={uiProps.imageBorderType == 'circular'}
                onChange={s => props.onChange(Object.assign({}, uiProps, { imageBorderType: s ? 'circular' : 'square' }))}
                label={`Circular ${uiProps.imageType == 'icon' ? 'Icon' : 'Image'}`}
            />
        </Property>
        <Property>
            <PropertyTitle>Image Size</PropertyTitle>
            <Input type='number' value={(uiProps.imageSize)} onChange={(e) => {
                props.onChange(Object.assign({}, uiProps, { imageSize: e }));
            }} />
        </Property>
        <Property>
            <PropertyTitle>Image Background Color</PropertyTitle>
            <CustomColorPicker contextData={props.contextData} color={uiProps.imageBackgroundColor}
                onChange={s => props.onChange(Object.assign({}, uiProps, { imageBackgroundColor: s }))}

            />
        </Property>
        {
            (uiProps.imageType == 'icon') && <>
                <Property>
                    <PropertyTitle>Icon</PropertyTitle>
                    <IconEditor value={uiProps.imageIcon}
                        onChange={s => props.onChange(Object.assign({}, uiProps, { imageIcon: s }))}

                    />
                </Property>
                <Property>
                    <PropertyTitle>Icon Color</PropertyTitle>
                    <CustomColorPicker contextData={props.contextData} color={uiProps.imageIconColor}
                        onChange={s => props.onChange(Object.assign({}, uiProps, { imageIconColor: s }))}

                    />
                </Property>
            </>
        }
        {
            (uiProps.imageType == 'image') && <>
                <Property>
                    <PropertyTitle>Image</PropertyTitle>
                    <ImagePicker
                        uxpContext={props.uxpContext}
                        imageUrl={uiProps.imageField || ''}
                        onChange={s => {
                            let newProps = applyAtPath(uiProps, '$.imageField', () => (s))
                            props.onChange({ ...newProps })
                        }}
                    />
                </Property>

            </>
        }
    </PropertyGroup>
        <PropertyGroup>
            <PropertyGroupTitle>Title</PropertyGroupTitle>
            <Property>
                <PropertyTitle>Text</PropertyTitle>
                <WidgetDesignerPillInput
                    value={uiProps.titleField || ''}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { titleField: s }))}
                    className="widget-designer-input"
                    contextData={props.contextData}
                />
            </Property>

            <Property>
                <PropertyTitle>Font Size</PropertyTitle>
                <Input type='number' value={(uiProps.titleSize)} onChange={(e) => {
                    props.onChange(Object.assign({}, uiProps, { titleSize: e }));
                }} />
            </Property>
            <Property>
                <PropertyTitle>Color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData} color={(uiProps.titleColor)} onChange={(e) => {
                    props.onChange(Object.assign({}, uiProps, { titleColor: e }));
                }} />
            </Property>
        </PropertyGroup>
        <PropertyGroup>
            <PropertyGroupTitle>Subtitle</PropertyGroupTitle>
            <Property>
                <PropertyTitle>Text</PropertyTitle>
                <WidgetDesignerPillInput
                    value={uiProps.subTitleField || ''}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { subTitleField: s }))}
                    className="widget-designer-input"
                    contextData={props.contextData}
                />
            </Property>

            <Property>
                <PropertyTitle>Font Size</PropertyTitle>
                <Input value={(uiProps.subTitleSize)} onChange={(e) => {
                    props.onChange(Object.assign({}, uiProps, { subTitleSize: e }));
                }} />
            </Property>
            <Property>
                <PropertyTitle>Color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData} color={(uiProps.subTitleColor)} onChange={(e) => {
                    props.onChange(Object.assign({}, uiProps, { subTitleColor: e }));
                }} />
            </Property>
        </PropertyGroup>
        <PropertyGroup>
            <PropertyGroupTitle>Top Labels</PropertyGroupTitle>
            <Property>
                {
                    LabelProperties(uiProps.topLabels,

                        (items) => {
                            let newProps = applyAtPath(uiProps, '$.topLabels', () => (items))
                            props.onChange({ ...newProps })
                        },
                        props.contextData
                    )
                }
            </Property>
        </PropertyGroup>
        <PropertyGroup>
            <PropertyGroupTitle>Bottom Labels</PropertyGroupTitle>
            <Property>
                {
                    LabelProperties(uiProps.bottomLabels,
                        (items) => props.onChange({ ...uiProps, bottomLabels: items }),
                        props.contextData
                    )
                }
            </Property>
        </PropertyGroup>
        <PropertyGroup>
            <PropertyGroupTitle>Actions</PropertyGroupTitle>

            <Property>
                <PropertyTitle>Card Click</PropertyTitle>
                <ActionEditorLink
                    uiProps={props.parentUIProps}
                    uxpContext={props?.uxpContext}
                    action={uiProps.onClick}
                    onChange={(e) => props.onChange(Object.assign({}, uiProps, { onClick: e }))}
                    contextData={props?.contextData}
                />
            </Property>
            <Property>
                <MultipleItemsProperty<ICFButton>
                    items={uiProps.buttons || []}
                    newItem={() => ({
                        icon: 'play',
                        color: "#424242",
                        backgroundColor: "#EEE",
                        onClick: { type: "open-url", redirectUrl: { url: 'about:blank' } }
                    })}
                    onChange={(items) => props.onChange({ ...uiProps, buttons: items })}
                    render={(item, onChange) => {
                        return <div className='cf-label-item'>


                            <div className='cf-m-f'>
                                <label>Icon</label>
                                <IconEditor onChange={(s) => onChange({ ...item, icon: s })} value={item.icon} />
                            </div>
                            <div className='cf-m-f'>
                                <label>Icon Color</label>
                                <CustomColorPicker contextData={props.contextData} onChange={(s) => onChange({ ...item, color: s })} color={item.color} />
                            </div>
                            <div className='cf-m-f'>
                                <label>Icon Background</label>
                                <CustomColorPicker contextData={props.contextData} onChange={(s) => onChange({ ...item, backgroundColor: s })} color={item.backgroundColor} />
                            </div>
                            <div className='cf-m-f'>
                                <ActionEditorLink
                                    uiProps={props.parentUIProps}
                                    uxpContext={props?.uxpContext}
                                    action={item.onClick}
                                    onChange={(s) => onChange(Object.assign({}, item, { onClick: s }))}
                                    contextData={props?.contextData}
                                />
                            </div>

                        </div>

                    }}
                    title=""

                />
            </Property>
        </PropertyGroup>
        <PropertyGroup>
            <PropertyGroupTitle>General</PropertyGroupTitle>
            <Property>
                <PropertyTitle>Borders</PropertyTitle>
                <Property>
                    <CustomColorPicker contextData={props.contextData} color={uiProps.borderColor}
                        onChange={(c) => props.onChange({ ...uiProps, borderColor: c })}
                    />
                </Property>
            </Property>
        </PropertyGroup>
    </>;
};